export const SDA_STATUS_NAME = ['NEW', 'APPROVED', 'DENIED']
export const SDA_STATUS_ID = {
  ALL: -1,
  NEW: 0,
  APPROVED: 1,
  DENIED: 2,
}
